import { ProdutoVitrineVirtual } from '@/models/Produto';
import store from '@/store/vuex'
import { Module, VuexModule, Mutation, getModule } from "vuex-module-decorators";

const VITRINE_VIRTUAL_STORAGE = 'VITRINE_VIRTUAL_STORAGE'

export interface ItemVitrineVirtual {
	produto: ProdutoVitrineVirtual
	quantidade: number | 0
}

export interface DadosVitrineVirtual {
	produtos: ItemVitrineVirtual[]
  }
  
const DEFAULT_STATE: DadosVitrineVirtual = {
	produtos: [],
}

function salvarNoLocalStorage(state: DadosVitrineVirtual) {
	localStorage.setItem(VITRINE_VIRTUAL_STORAGE, JSON.stringify(state))
}
  
function lerDoLocalStorage(): DadosVitrineVirtual {
	const raw = localStorage.getItem(VITRINE_VIRTUAL_STORAGE)
	return raw ? JSON.parse(raw) : DEFAULT_STATE
}

@Module({
	name: "VitrineVirtualStore",
	namespaced: true,
	dynamic: true,
	store,
})
export default class VitrineVirtualStore extends VuexModule {
	dados: DadosVitrineVirtual = lerDoLocalStorage()

	@Mutation
	setDados(parcial: Partial<DadosVitrineVirtual>) {
		this.dados = { ...this.dados, ...parcial } 
		salvarNoLocalStorage(this.dados)
	}
  
	@Mutation
	resetar() {
		this.dados = { ...DEFAULT_STATE }
		salvarNoLocalStorage(this.dados)
	}
}

export const VitrineVirtualModule = getModule(VitrineVirtualStore)
